import { useState } from 'react'

//TODO refactor it

type Timer = ReturnType<typeof setTimeout | any>
type SomeFunction = (...args: any[]) => void

const useDebounce = <Func extends SomeFunction>(func: Func, delay = 1000) => {
  const [timer, setTimer] = useState<Timer>()

  const debouncedFunction = ((...args) => {
    const newTimer = setTimeout(() => {
      func(...args)
    }, delay)
    clearTimeout(timer)
    setTimer(newTimer)
  }) as Func

  return debouncedFunction
}

export default useDebounce
